(function () {
  'use strict';

  angular
      .module('tfc.Nav')
      .controller('MainNavCtrl', MainNavCtrl)
      .directive('tfcMainNav', tfcMainNav);

  // @ngInject
  function MainNavCtrl($injector, $scope, $element, $document, Nav, Auth) {
    var vm = this,
        isExpanded = false,
        mainItems,
        rightItems,
        userItems;

    function inject(fnName) {
      return function (item) {
        return $injector.invoke(item[fnName]);
      };
    }

    vm.getText = inject('getText');
    vm.onClick = inject('onClick');
    vm.canAccess = inject('canAccess');

    vm.isActive = function (item) {
      return _.some([item].concat(item.children || []), inject('isActive'));
    };

    vm.isExpanded = function () {
      return isExpanded;
    };

    vm.toggle = function () {
      isExpanded = !isExpanded;
    };

    vm.appTitle = function () {
      return vm.getText(Nav.appTitle());
    };

    vm.appWelcome = function () {
      return vm.getText(Nav.appWelcome());
    };

    vm.mainItems = function () {
      return vm.user ? mainItems : [];
    };

    vm.rightItems = function () {
      return vm.user ? rightItems : [];
    };

    vm.userItems = function () {
      return vm.user ? userItems : [];
    };

    $scope.$on('$stateChangeSuccess', function () {
      isExpanded = false;
    });

    $document.on('click', function (e) {
      if (!$element[0].contains(e.target)) {
        isExpanded = false;
        $scope.$apply();
      }
    });

    $scope.$watch(Nav.mainMenu, function (items) {
      mainItems = items;
    });
    $scope.$watch(Nav.rightMenu, function (items) {
      rightItems = items;
    });
    $scope.$watch(Nav.userMenu, function (items) {
      userItems = items;
    });
    // we don't want to watch getUser because it returns a new one each time,
    // so we'd have to
    $scope.$watch(Auth.isAuthenticated, function () {
      vm.user = Auth.getUser();
    });

    $scope.$watch(vm.appTitle, function (title) {
      if (title) {
        document.title = title + ' | True Fit';
      }
    });
  }

  // @ngInject
  function tfcMainNav() {
    return {
      restrict : 'E',
      controller : 'MainNavCtrl as vm',
      bindToController : true,
      templateUrl : 'Nav/MainNav.tmpl.html',
      scope : {
        fullWidth : '='
      }
    };
  }

})();
